import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type academicYearDetails = {
  id: string;
  years: string;
  displayYear: number;
  isActive: boolean;
  activatedAt: string; // ISO date string
  ocAllIn: boolean;
  plc: boolean;
  dts: boolean;
  thirtyForThirty: boolean;
  createdAt: string; // ISO date string
  updatedAt: string; // ISO date string
};

interface academicYearState {
  academicYearDetails: academicYearDetails | null;
}

let initialState: academicYearState = {
  academicYearDetails: null,
};

const AcademicYearSliceReducer = createSlice({
  name: "AcademicYear",
  initialState,
  reducers: {
    setAcademicYearDetails(
      state,
      action: PayloadAction<academicYearDetails | null>,
    ) {
      console.log("academicYearSlice:", action?.payload);
      state.academicYearDetails = action.payload;
    },
  },
});

export const { setAcademicYearDetails } = AcademicYearSliceReducer.actions;

export default AcademicYearSliceReducer.reducer;
